<template>
  <div>
    <Header
      :seller-logo-url="sellerLogoUrl"
      :hide-search="true"
      :logged-in="loggedIn"
      :hide-buyer-id-on-mobile="true"
      :show-category-trigger="false"
    />

    <main class="content">
      <div
        v-if="product"
        :key="product.id"
        class="product-show"
      >
        <router-link to="/">
          <button
            id="back-to-main"
            class="btn btn-tertiary"
            style="margin-bottom: 3rem;"
          >
            <i class="fas fa-chevron-left" />&nbsp;
            Back to Shopping
          </button>
        </router-link>
        <div class="product-show-layout">
          <div class="images-container">
            <ImageGridView :images="product.images" />
          </div>
          <div class="product-details">
            <div v-if="product.on_sale" class="on-sale-end-container">
              <span><i class="fa-sharp fa-solid fa-tags" /> On sale</span>{{ product.sale_end_at ? ` until ${product.sale_end_at}!` : '' }}
            </div>
            <h1 v-if="product" style="font-size: 3rem; margin-top: 0">
              {{ product.name }}
            </h1>
            <div class="category-container">
              <div v-for="(category, index) in product.categories" :key="category.id">
                <router-link :to="{path: '/', query: {cid: category.id}}">
                  {{ category.name }}
                </router-link>

                <span v-if="index + 1 != product.categories.length">,&nbsp;</span>
              </div>
            </div>
            <div class="price-and-cart-container">
              <div class="total-box">
                <div class="gross" :class="{'on-sale': product.on_sale}">
                  ${{ product.price }}
                </div>
                <div v-if="product.on_sale" class="gross origin-price">
                  ${{ product.origin_price }}
                </div>
              </div>
              <div class="add-cart-container">
                <input
                  v-model="quantity"
                  class="quantity-input large"
                  type="number"
                  min="1"
                  value="1"
                >
                <button id="add-to-cart" class="btn block-btn" @click="addToCart()">
                  <i class="fas fa-shopping-cart" /> &nbsp;
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="product-description-container">
          <h2>Product Description</h2>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="product.description" />
          <!--eslint-enable-->
        </div>

        <div v-if="related_products.length" class="related-products">
          <h2>Items you may also be interested in</h2>
          <ProductGrid :products="related_products" />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from '../header.vue';
import ImageGridView from "../../image_grid_view";
import ProductGrid from '../product_grid';
import {fetchProduct} from "../../../shopfront/cartDataService";

export default {
  components: {ImageGridView, Header, ProductGrid},
  beforeRouteUpdate(to, from, next) {
    // Call the API query method when the URL changes
    this.productId = to.params.productId;
    this.getData();
    next();
  },
  props: {
    sellerLogoUrl: {type: String, required: true},
    loggedIn: {type: Boolean, required: true},
  },
  data() {
    return {
      cart: this.initCart,
      productId: this.$route.params.productId,
      product: null,
      quantity: 1,
      related_products: [],
    };
  },
  mounted() {
    this.productId = this.$route.params.productId;
    this.getData();
  },
  methods: {
    addToCart: function () {
      this.$store.dispatch('addProduct', {productId: this.productId, quantity: parseInt(this.quantity, 10)});
    },
    getData: function () {
      let vm = this;
      let buyerId = this.$store.state.buyerDetails.buyer_id;

      fetchProduct(this.productId, this.$store.state.sellerPid, buyerId, function (response) {
        vm.product = response.product;
        vm.related_products = response.related_products;
      });
    },
  },
};
</script>
